import { render, staticRenderFns } from "./ptStatus.vue?vue&type=template&id=7dcfc647&"
import script from "./ptStatus.vue?vue&type=script&lang=js&"
export * from "./ptStatus.vue?vue&type=script&lang=js&"
import style0 from "./ptStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ptStatus.vue"
export default component.exports